module.exports = __webpack_public_path__ + "img/fundermax-obra-1-2.92bda331.jpg";